import JSZip from "jszip";
import { saveAs } from "file-saver";
// Util function, will get removed in production when API's are integrated
export function getRandomElementFromArray(arr = []) {
  return arr[Math.floor(Math.random() * arr.length)]
}

//Util function to convert column text, (remove spaces, put an underscore and converts into a lowercase value)
export function getColumnField(str = "") {
  let strKey = str.replace(/\s_\s+/g, ' ');
  strKey = strKey.replaceAll(' ', '_')
  return strKey
}

// function to convert file object into base64 URL
export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
})

// function to convert file base64 URL into object 
export const urltoFile = (url, filename, mimeType) => {
  return (fetch(url)
    .then(function (res) { return res.arrayBuffer(); })
    .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
  );
}
export const toTitleCase = (str) => {
  if ((typeof str === "string") && str.length >= 1) {
    if (!(str.trim().includes(" "))) //the string does not have spaces
      return str[0].toUpperCase() + str.slice(1);
    if (str.trim().includes(" ")) //the string does have spaces
      return str
        .trim()
        .split(" ")
        .filter(word => word !== "")
        .map((word) => word[0].toUpperCase() + word.slice(1))
        .join(" ");
  }
}

export const downloadZip = async (documents, zipFileName = "Documents") => {
  var zip = new JSZip();
  const zipFolder = zip.folder(zipFileName);

  const fileFetcher = await Promise.all(
    documents.map(async (document, index) => {
      const res = await fetch(document.link);
      return res.blob();
    })
  );

  fileFetcher.forEach((fileBlob, index) => {
    let fileExtension = ""
    
    if (fileBlob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      fileExtension = 'docx'
    }

    if (fileBlob.type === 'application/pdf') {
      fileExtension = 'pdf'
    }
    else if (fileBlob.type === "image/jpeg" || fileBlob.type === "image/png" || fileBlob.type === "image/jpg") {
      fileExtension = fileBlob.type.split("/")[1]
    }
    zipFolder.file(`${documents[index].name}.${fileExtension}`, fileBlob, { blob: true });

  });

  zip.generateAsync({ type: "blob" }).then(function (content) {
    saveAs(content, `${zipFileName}.zip`);
  });
}
